import React  , { useEffect}from 'react'
import './Home.css'
import  HeaderImg from './assets/header-svg.svg'

function Home() {

  useEffect(()=> {
    document.title = "LeeBakes - Home"
    console.clear();
  })
  return (
    <>
    <div id='full-div'>
      <div className="center-div">
      <div className="left-content">
        <h1 data-aos="fade-right">Hey! Its lisha from</h1>
        <h1 id='sh' data-aos="fade-right">LeeBakes!</h1>
        <p className='my-3'   data-aos="fade-right">I am a talented and passionate homebaker.</p>
        <a href="https://www.instagram.com/leebakes2022/" target='_blank'><button className='btn btn-outline-primary rounded-pill btn-f'>Order Now</button></a>
      </div>
      <div className="right-content"  data-aos="fade-left">
        <img src={HeaderImg} alt="Failed Fetching SVG" width='400' className='header-svg' />
      </div>
      </div>
    </div>
    </>
  )
}

export default Home